import React from 'react';
import TestInfoClasses from '../Tests/TestInfo.module.css';
import { viewResult } from '../../utils/api';
export default function ResultsTable(props) {

	const historyData=props.data;
	const historyTableData=props.tf;
	const labid='XYZLABS';
	const token='';
	const LabtestId='';
	
	const HandleOpenPdf = async (accession, pdffilename) => {
		console.log('pdfilename', pdffilename, accession);

		const req = await fetch(
		  viewResult(pdffilename,accession)
		);

	  };

return (
  <div className={`${TestInfoClasses.testInfoContent} ${TestInfoClasses.card}`}
  		onClick={() => {
                HandleOpenPdf(historyData.Accession, historyData.Accession);
		}}
  >
	<div className={TestInfoClasses.headerRow}	>
      {historyTableData.map(({ Label, DBColumn, FIELDVALUE, Name }, idx) => (
        <div key={idx} className={TestInfoClasses.headerCol}>
				{historyData[DBColumn] || "\u00A0"}
        </div>
      ))}
	 </div>
	 <div>
			{historyData.PerformedTests?.map((x, j) => (
				<div key={j} className={TestInfoClasses.headerCol}>
					{x.OrderCodeName}{" "}
						<span style={{ color: "blue" }}>
						  {{
							F: "Final",
							C: "Cancelled",
							P: "In Progress"
						  }[x.OBRStatus] || ""}
						</span>
				</div>
			))}
			<a target="_blank">
				CLICK HERE TO VIEW YOUR RESULTS
			</a>
	 </div>
  </div>
);
}
